import * as React from 'react';
import { SVGProps } from 'react';

const IconGasSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 0a1 1 0 1 0 0 2v2a2 2 0 0 0-2 2v7a2 2 0 0 0 1 1.732V15a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-.268A2 2 0 0 0 13 13V6a2 2 0 0 0-2-2V2a1 1 0 1 0 0-2H5zm4 2v2H7V2h2zm0 10.42a.85.85 0 0 1-.072.352A2 2 0 0 0 10 11c0-.5-.25-.875-.5-1.25S9 9 9 8.5a7.249 7.249 0 0 0-.95.746A3.08 3.08 0 0 1 8 7.5C7 8 6 9.5 6 11a2 2 0 0 0 1.072 1.772A.856.856 0 0 1 7 12.42c0-.199.18-.42.388-.675.281-.346.612-.752.612-1.245 1 1 1 1.608 1 1.92z"
    />
  </svg>
);
export default IconGasSizeS;
